import { defineAsyncComponent } from 'vue'
export default {
  frameable: defineAsyncComponent(() => import("/src/Frontend/layouts/Frameable.vue").then(m => m.default || m)),
  headless: defineAsyncComponent(() => import("/src/Frontend/layouts/Headless.vue").then(m => m.default || m)),
  unsticky: defineAsyncComponent(() => import("/src/Frontend/layouts/Unsticky.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/src/Frontend/layouts/default.vue").then(m => m.default || m))
}